import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, cn } from '@mf-tools/domains-ui';
import { Container } from '../components';

export interface ProblemProps {
  className?: string;
}

export function Problem({ className }: ProblemProps): React.ReactElement {
  return (
    <section className={cn('py-14 sm:py-20', className)} aria-labelledby="problem-title">
      <Container>
        <div className="grid gap-8 lg:grid-cols-2 lg:items-start">
          <div className="space-y-4">
            <h2 id="problem-title" className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              Operational chaos kills momentum.
            </h2>
            <p className="text-base leading-relaxed text-muted-foreground sm:text-lg">
              Founders don’t lose because they can’t build — they lose because operations expands into a maze of vendors,
              handoffs, and one-off processes. Tool sprawl creates busywork, slows decisions, and turns every hire into
              a new compliance risk.
            </p>
          </div>

          <Card>
            <CardHeader>
              <CardTitle className="text-base">What it feels like</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="grid gap-3 text-sm text-muted-foreground">
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                  Too many tools and vendors
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                  Manual work and context switching
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                  Security &amp; compliance expected earlier than ever
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                  Ops slows speed and burns runway
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </Container>
    </section>
  );
}

